import { useState } from 'react';
import InitFilters from './components/InitFiltering';
const defaultIdentityType = 'username';
const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [isOpendialog, setIsOpenDialog] = useState(false);
  const [identityType, setIdentityType] = useState(defaultIdentityType);
  const [identity, setIdentity] = useState('');
  const [birthDate, setBirthDate] = useState(null);
  const [userType, setUserType] = useState(true);
  const [isLoadingNewPayer, setIsLoadingNewPayer] = useState(false);
  const [isLoadingListPayer, setIsLoadingListPayer] = useState(false);
  const [selectedRowPayerFinger, setSelectedRowPayerFinger] = useState({});
  const [selectRowForPayer, setSelectRowForPayer] = useState(null);
  const [removeDialog, setRemoveDialog] = useState({});
  const [selectedRow, setSelectedRow] = useState(false);
  const [page, setPage] = useState(0);
  const [userDetail, setUserDetail] = useState();
  const [pageTitle, setPageTitle] = useState('لیست گروه کاربران ');
  const [superAdminObject, setSuperAdminObject] = useState({ isAdmin: false, getData: false });
  const [isLoadingSupreAdmin, setIsLoadingSupreAdmin] = useState(false);
  const [filters, setFilters] = useState(InitFilters());
  const [openFilterDialog, setOpenFilterDialog] = useState(false);

  const [isLoadingFilter, setIsLoadingFilter] = useState(false);
  const [isLoadingCheckSuperAdmin, setIsLoadingCheckSuperAdmin] = useState(true);
  const [copyOriginalFilter, setCopyOriginalFilter] = useState(null);
  const [copyTempFilter, setCopyTempFilter] = useState(null);
  const [copyOpenDgFilter, setCopyOpenDgFilter] = useState(null);
  return {
    page, setPage,
    loading,
    setLoading,
    setFilterParams,
    size,
    setSize,
    identity, setIdentity,
    loadingBtn, setLoadingBtn,
    selectedRow, setSelectedRow,
    isOpendialog, setIsOpenDialog,
    removeDialog, setRemoveDialog,
    identityType, setIdentityType,
    selectRowForPayer, setSelectRowForPayer,
    selectedRowPayerFinger, setSelectedRowPayerFinger,
    isLoadingListPayer, setIsLoadingListPayer,
    isLoadingNewPayer, setIsLoadingNewPayer,
    userType, setUserType,
    birthDate, setBirthDate,
    userDetail, setUserDetail,
    pageTitle, setPageTitle,
    superAdminObject, setSuperAdminObject,
    isLoadingSupreAdmin, setIsLoadingSupreAdmin,
    filters, setFilters,
    openFilterDialog, setOpenFilterDialog,
    isLoadingFilter, setIsLoadingFilter,
    copyOriginalFilter, setCopyOriginalFilter,
    copyTempFilter, setCopyTempFilter,
    copyOpenDgFilter, setCopyOpenDgFilter,
    isLoadingCheckSuperAdmin, setIsLoadingCheckSuperAdmin
  };
};

export default useCustomHook;
